import {useEffect} from 'react'
import { useIntl } from 'react-intl'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {useNavigate, useParams} from 'react-router'
import { toast } from 'react-toastify'
import {PageTitle} from '../../../../../_metronic/layout/core'
import { getDetailTransactions, putTransactions } from '../../../../modules/services/transactions.service'
import {getBreadCrumbs} from '../../breadcrumbs'
import FormTransactions from '../form/FormTransactions'



const TransactionManagement = () => {
   const navigate = useNavigate()
   const {id} = useParams<{id: string}>()

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    } 
  }, [])

  const {data:data, isLoading} = useQuery(['getDetailTransactions', id], async () => await getDetailTransactions(id) )
  const handleChange = (form: any) => {
    let data ={
      form, 
      id
    }
    mutate(data)
  }

   const {mutate, isLoading: loading}= useMutation(putTransactions, {
    onSuccess: async () => {
      toast.success("Update Data Success")
      navigate('/loyalty-point/transaction-management')
        
    },
    onError(error : any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const initLoad ={
    date: data?.TransactionDate,
    invoiceId: data?.InvoiceNumber,
    detailTransactions: data?.transaction_details,
    status: data?.Status,
    MemberId: data?.Member.id,
  }

  

  return (
    <>
        <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Transaction Update</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
       <div className='card-body border-top p-9'>
          {
            !isLoading &&  <FormTransactions handleChange={handleChange} id={id} initLoad={initLoad} loadings={loading} />
          }
          
        </div>
      </div>
    </div>
    </>
  )
}


const TransactionManagementWrapper = () => {
    const intl = useIntl()
    return (
      <>
        <PageTitle breadcrumbs={getBreadCrumbs('loyalty-point/redemption-management/create')}>
          {intl.formatMessage({id: 'MENU.REDEMPTION_MANAGEMENT'})}
        </PageTitle>
        <TransactionManagement />
      </>
    )
  }
  
  export default TransactionManagementWrapper